import { apiClient, type CreateShipmentCategoriesDto } from '@/libs/api'

export type CreateShipmentCategoriesRequest = {
  tenantKey: string
  dto: CreateShipmentCategoriesDto
}

export const createShipmentCategories = async ({
  tenantKey,
  dto
}: CreateShipmentCategoriesRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .shipment_categories.$post({ body: dto })
  return { data, errors }
}
